import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

import About from "./pages/About";
import Contact from "./pages/Contact";
import SigningPending from "./pages/SigningPending";
import SigningCompleted from "./pages/SigningCompleted";
import SigningNew from "./pages/SigningNew";
import Paperwork from "./pages/Paperwork";
import Error from "./pages/Error";
import Navigation from "./components/Navigation";
import TokenRedirect from "./pages/TokenRedirect";
import "./App.css";
import { CircularProgress } from "@mui/material";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [tokenExists, setTokenExists] = useState(false);
  console.log("commit di test 1");
  const location = window.location.pathname;
  const hideNavigation = location === "/token-redirect";

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setTokenExists(true);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress style={{ color: "#1b2838" }} />
      </div>
    );
  }

  return (
    <BrowserRouter>
      {!hideNavigation && tokenExists && <Navigation />}
      <Container fluid="true">
        <Col>
          <Routes>
            <Route
              path="/"
              element={<Navigate to="/signing-pending" replace />}
            />
            <Route path="/token-redirect" element={<TokenRedirect />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/signing-pending" element={<SigningPending />} />
            <Route path="/signing-completed" element={<SigningCompleted />} />
            <Route path="/new-signing" element={<SigningNew />} />
            <Route path="/paperwork/:id" element={<Paperwork />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </Col>
      </Container>
    </BrowserRouter>
  );
};

export default App;
